
import React, { useContext, useState, useEffect, useRef } from "react";
import { ConfigContext } from "../context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { Languages } from "../Utils/Languages";
import LoaderView from "./LoaderView";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { Icon } from "@iconify/react/dist/iconify.js";

const Aigenerated = () => {

    const [currentStep, setCurrentStep] = useState(1);
    const [PageData, setPageData] = useState();
    const [data, setdata] = useState({
        business: null,
        customer: null,
        items: [],
        otherdetails: null
    })

    const { state, dispatch } = useContext(ConfigContext);
    const navigate = useNavigate();
    const [desc, setdesc] = useState("");
    const timeoutRef = useRef(null);
    const Lables =
        ["Alright, let's begin. May I know your business name, please?",
            "Wonderful! Could you please share the customer's name?",
            "Great! Now, please provide the item details including name, quantity, and price.",
            "Almost there! Kindly tell us any additional details you'd like to include.",
        ]

    const PlaceHolders =
        ["Enter your business name",
            "Enter your customer name",
            "Enter your item details including name, quantity, and price.",
            "Enter additional details",
        ]


    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    useEffect(() => {
        setdesc(transcript);
    }, [transcript]);

    useEffect(() => {
        if (state?.BUSINESSES?.length === 1) { speak(Lables[1]) }
        else {
            speak(Lables[currentStep - 1])
        }
        setdesc("")
    }, [])
    useEffect(() => {
        if (state?.BUSINESSES?.length === 1) {
            setdata(prev => ({ ...prev, business: state?.BUSINESSES[0] }));
            setCurrentStep(2);
            speak(Lables[1])
        }
    }, [state?.BUSINESSES]);

    const speak = (text) => {
        const synth = window.speechSynthesis;
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = "en-RU";

        const voices = synth.getVoices();

        // Find the softest, most natural-sounding female voice
        const politeVoice = voices.find(
            (voice) =>
                voice.name.toLowerCase().includes("google us english") || // Chrome's best soft female voice
                voice.name.toLowerCase().includes("zira") ||               // Windows Zira
                voice.name.toLowerCase().includes("susan") ||
                voice.name.toLowerCase().includes("emma") ||
                (voice.name.toLowerCase().includes("female") && voice.lang.includes("en"))
        );

        if (politeVoice) {
            utterance.voice = politeVoice;
        }

        // 💡 These settings make it sound calm, clear, and polite
        utterance.rate = 0.75;  // Slower = softer tone
        utterance.pitch = 1.2;  // Slightly higher pitch = friendly
        utterance.volume = 0.9; // Slightly lowered volume = gentle delivery

        synth.cancel(); // Clear any queued speech
        synth.speak(utterance);
    };



    const toggleListening = () => {
        if (!browserSupportsSpeechRecognition) {
            alert("Speech recognition not supported in your browser.");
            return;
        }

        if (listening) {
            SpeechRecognition.stopListening();
        } else {
            resetTranscript();
            SpeechRecognition.startListening({ continuous: true });
            timeoutRef.current = setTimeout(() => {
                SpeechRecognition.stopListening();
                alert("No voice input detected for 1 minute. Stopped listening.");
            }, 60000);
        }


    };

    function parseItems(input) {
        const pattern = /(\d+)\s+([a-zA-Z ]+?)\s+at\s+(\d+)/gi;
        const matches = [...input.matchAll(pattern)];

        return matches.map(match => {
            const qty = parseInt(match[1]);
            const name = match[2].trim();
            const price = parseFloat(match[3]);
            return { name, qty, price };
        });
    }


    const SaveBusiness = () => {
        const formated_data = desc?.trim();
        if (!formated_data) return;

        const foundBusiness = state?.BUSINESSES?.find(
            (business) =>
                business?.companyName?.toLowerCase() === formated_data?.toLowerCase()
        );

        setdata(prevdata => {
            const newData = {
                ...prevdata,
                business: foundBusiness || null,
            };

            // Only call nextStep if business is found
            if (foundBusiness) {
                nextStep();
            }
            else{
                alert("no business found")
            }
            return newData;
        });

        setdesc("");
        SpeechRecognition.stopListening();
    };


    const SaveCustomer = () => {
        const formated_data = desc;

        let customer = state?.CUSTOMERS?.find(
            (client) =>
                client?.customer?.toLowerCase() ===
                formated_data?.toLowerCase()
        ) || { customer: formated_data };

        setdata(prevdata => ({
            ...prevdata,
            customer: customer
        }))

        setdesc("")

    }
    const parseOtherDetails = (input, items) => {
        const pattern = /(paid|unpaid)\s+with\s+(?:(\d+)%\s+GST|no\s+GST)\s+and\s+(?:(\d+)%\s+discount|no\s+discount)/i;
        const match = input.match(pattern);

        if (!match) return null;

        const status = match[1]?.toLowerCase() === "paid";
        const gst = match[2] ? parseFloat(match[2]) : 0;
        const discount = match[3] ? parseFloat(match[3]) : 0;
        const baseAmount = items?.reduce((sum, item) => {
            const itemTotal = item.price * item.quantity;
            return sum + itemTotal;
        }, 0);
        const discountAmount = (baseAmount * discount) / 100;

        const subtotalAfterDiscount = baseAmount - discountAmount;

        const gstAmount = (subtotalAfterDiscount * gst) / 100;
        const totalAmount = subtotalAfterDiscount + gstAmount;

        return { status, gst, discount, gstAmount, discountAmount, totalAmount, baseAmount };
    };


    const SaveOtherDetails = () => {
        const parsedDetails = parseOtherDetails(desc, data?.items);
    
        const currentBusiness = data?.business; // get it before state update
    
        setdata((prevData) => {
            const newData = {
                ...prevData,
                otherdetails: parsedDetails,
            };
    
            // Navigate only if both otherdetails and business exist
            if (parsedDetails && currentBusiness) {
                navigate("/invoice-add", {
                    state: {
                        parsed_data: JSON.stringify(newData),
                    },
                });
            }
    
            return newData;
        });
    
        setdesc("");
        SpeechRecognition.stopListening();
    };
    


    const SaveItems = () => {
        const parsedItems = parseItems(desc); // Array of { item, qty, price }
        const updatedItems = [];

        parsedItems?.map((item, index) => {
            const matched = state?.SOLDITEMS?.find(
                (soldItem) =>
                    soldItem?.name?.toLowerCase() === item?.name?.toLowerCase());

            if (matched) {
                updatedItems.push({
                    ...matched,
                    quantity: item?.qty || 1,
                    price: item?.price || matched.price,
                    amount: (item?.price || matched.price) * (item?.qty || 1),
                });
            } else {
                updatedItems.push({
                    srNo: 1,
                    name: item?.name,
                    subtitle: null,
                    quantity: item?.qty || 1,
                    price: item?.price || 0,
                    amount: (item?.price || 0) * (item?.qty || 1),
                });
            }
        });

        setdata((prevdata) => ({
            ...prevdata,
            items: updatedItems,
        }));
        setdesc("");

    }


    const OnCreatePress = () => {
        if (data?.business) {
            navigate("/invoice-add", {
                state: {
                    parsed_data: JSON.stringify(data),
                },
            });
        }
    };

    const nextStep = () => {
        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
            speak(Lables[currentStep])
        }
    };

    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <div className='col-md-12'>
            <div className='card'>
                <div className='card-body'>
                    <h6 className='mb-4 text-xl'>Smart Invoice Description Parser</h6>
                    <p className='text-neutral-500'>
                        Fill up your details and proceed next steps.
                    </p>
                    {/* Form Wizard Start */}
                    <div className='form-wizard' >
                        <form action='#' method='post'>
                            <div className='form-wizard-header overflow-x-auto scroll-sm pb-8 my-32' style={{ display: "flex", justifyContent: "space-around" }}>
                                <ul className='list-unstyled form-wizard-list style-three'>
                                    <li
                                        className={`form-wizard-list__item d-flex align-items-center gap-8
                    ${[2, 3, 4].includes(currentStep) && "activated"}
                  ${currentStep === 1 && "active"} `}
                                    >
                                        <div className='form-wizard-list__line'>
                                            <span className='count'>1</span>
                                        </div>
                                        <span className='text text-xs fw-semibold'>
                                            Add Business Details
                                        </span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item d-flex align-items-center gap-8
                    ${[3, 4].includes(currentStep) && "activated"}
                  ${currentStep === 2 && "active"} `}
                                    >
                                        <div className='form-wizard-list__line'>
                                            <span className='count'>2</span>
                                        </div>
                                        <span className='text text-xs fw-semibold'>
                                            Add Customer Details
                                        </span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item d-flex align-items-center gap-8
                    ${[4].includes(currentStep) && "activated"}
                  ${currentStep === 3 && "active"} `}
                                    >
                                        <div className='form-wizard-list__line'>
                                            <span className='count'>3</span>
                                        </div>
                                        <span className='text text-xs fw-semibold'>Add Items Details</span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item d-flex align-items-center gap-8

                  ${currentStep === 4 && "active"} `}
                                    >
                                        <div className='form-wizard-list__line'>
                                            <span className='count'>4</span>
                                        </div>
                                        <span className='text text-xs fw-semibold'>Add Other Details</span>
                                    </li>
                                </ul>
                            </div>
                            <fieldset
                                className={`wizard-fieldset ${currentStep === 1 && "show"} `}
                            >
                                <div className='row gy-3'>

                                    <form className="px-4 py-5" style={{ maxWidth: "800px", margin: "0 auto" }}>
                                        {/* Label */}
                                        <div className="text-center mb-3">
                                            <label className="form-label fw-bold fs-5 ">
                                                {Lables[0]}
                                            </label>
                                        </div>

                                        {/* Textarea + Voice Button */}
                                        <div className="d-flex flex-column align-items-center gap-3 mb-3 ">
                                            <textarea
                                                className="form-control"
                                                style={{ width: "100%", maxWidth: "600px" }}
                                                rows={4}
                                                value={desc}
                                                onChange={(e) => setdesc(e.target.value)}
                                                placeholder={PlaceHolders[0]}
                                            />

                                            <div className="mic-wrapper mt-3">
                                                {listening && <span className="pulse-ring" />}
                                                <button
                                                    type="button"
                                                    onClick={toggleListening}
                                                    className="mic-btn"
                                                >
                                                    <i className={`fa ${listening ? "fa-stop" : "fa-microphone"}`}></i>
                                                </button>
                                            </div>

                                        </div>

                                        {/* Instruction */}
                                        <div className="text-center  mb-4">
                                            <small className="orm-label">
                                                Type or speak your business name
                                            </small>
                                        </div>

                                    </form>
                                    <div
                                        className="d-flex gap-2 justify-content-end"
                                        style={{ marginTop: 20 }}
                                    >
                                        <button
                                            type="reset"
                                            onClick={() => {
                                               navigate(-1)
                                                SpeechRecognition.stopListening();
                                            }}
                                            className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                        >
                                            Back
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                            onClick={SaveBusiness}
                                        >
                                            <Icon icon="simple-line-icons:check" className="text-xl" />
                                            Next
                                        </button>

                                    </div>
                                </div>
                            </fieldset>
                            <fieldset
                                className={`wizard-fieldset ${currentStep === 2 && "show"} `}
                            >
                                <div className='row gy-3'>

                                    <form className="px-4 py-5" style={{ maxWidth: "800px", margin: "0 auto" }}>
                                        {/* Label */}
                                        <div className="text-center mb-3">
                                            <label className="form-label fw-bold fs-5">
                                                {Lables[1]}
                                            </label>
                                        </div>

                                        {/* Textarea + Voice Button */}
                                        <div className="d-flex flex-column align-items-center gap-3 mb-3 ">
                                            <textarea
                                                className="form-control"
                                                style={{ width: "100%", maxWidth: "600px" }}
                                                rows={4}
                                                value={desc}
                                                onChange={(e) => setdesc(e.target.value)}
                                                placeholder={PlaceHolders[1]}
                                            />

                                            <div className="mic-wrapper mt-3">
                                                {listening && <span className="pulse-ring" />}
                                                <button
                                                    type="button"
                                                    onClick={toggleListening}
                                                    className="mic-btn"
                                                >
                                                    <i className={`fa ${listening ? "fa-stop" : "fa-microphone"}`}></i>
                                                </button>
                                            </div>

                                        </div>

                                        {/* Instruction */}
                                        <div className="text-center mb-4">
                                            <small>
                                                Type or speak your Customer name
                                            </small>
                                        </div>

                                    </form>
                                    <div
                                        className="d-flex gap-2 justify-content-end"
                                        style={{ marginTop: 20 }}
                                    >
                                        <button
                                            type="reset"
                                            onClick={() => {
                                                data?.business ? navigate(-1) : prevStep();

                                                SpeechRecognition.stopListening();
                                            }}
                                            className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                        >
                                            Back
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                            onClick={() => {

                                                nextStep();
                                                SaveCustomer();
                                                SpeechRecognition.stopListening();
                                            }}
                                        >
                                            <Icon icon="simple-line-icons:check" className="text-xl" />
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset
                                className={`wizard-fieldset ${currentStep === 3 && "show"} `}
                            >
                                <div className='row gy-3'>

                                    <form className="px-4 py-5" style={{ maxWidth: "800px", margin: "0 auto" }}>
                                        {/* Label */}
                                        <div className="text-center mb-3">
                                            <label className="form-label fw-bold fs-5 ">
                                                {Lables[2]}

                                            </label>
                                        </div>

                                        {/* Textarea + Voice Button */}
                                        <div className="d-flex flex-column align-items-center gap-3 mb-3 ">
                                            <textarea
                                                className="form-control"
                                                style={{ width: "100%", maxWidth: "600px" }}
                                                rows={4}
                                                value={desc}
                                                onChange={(e) => setdesc(e.target.value)}
                                                placeholder={PlaceHolders[2]}

                                            />

                                            <div className="mic-wrapper mt-3">
                                                {listening && <span className="pulse-ring" />}
                                                <button
                                                    type="button"
                                                    onClick={toggleListening}
                                                    className="mic-btn"
                                                >
                                                    <i className={`fa ${listening ? "fa-stop" : "fa-microphone"}`}></i>
                                                </button>
                                            </div>

                                        </div>

                                        {/* Instruction */}
                                        <div className="text-center mb-4">
                                            <small>
                                                Type or speak Add 2 notebooks at 50 and 3 pens at 10 each.
                                            </small>
                                        </div>

                                    </form>
                                    <div
                                        className="d-flex gap-2 justify-content-end"
                                        style={{ marginTop: 20 }}
                                    >
                                        <button
                                            type="reset"
                                            onClick={() => {
                                                prevStep();
                                                SpeechRecognition.stopListening();
                                            }}
                                            className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                        >
                                            Back
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                            onClick={() => {

                                                nextStep();
                                                SaveItems();
                                                SpeechRecognition.stopListening();
                                            }}
                                        >
                                            <Icon icon="simple-line-icons:check" className="text-xl" />
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset
                                className={`wizard-fieldset ${currentStep === 4 && "show"} `}
                            >
                                <div className='row gy-3'>

                                    <form className="px-4 py-5" style={{ maxWidth: "800px", margin: "0 auto" }}>
                                        {/* Label */}
                                        <div className="text-center mb-3">
                                            <label className="form-label fw-bold fs-5">
                                                {Lables[3]}
                                            </label>
                                        </div>

                                        {/* Textarea + Voice Button */}
                                        <div className="d-flex flex-column align-items-center gap-3 mb-3 ">
                                            <textarea
                                                className="form-control"
                                                style={{ width: "100%", maxWidth: "600px" }}
                                                rows={4}
                                                value={desc}
                                                onChange={(e) => setdesc(e.target.value)}
                                                placeholder={PlaceHolders[3]}

                                            />

                                            <div className="mic-wrapper mt-3">
                                                {listening && <span className="pulse-ring" />}
                                                <button
                                                    type="button"
                                                    onClick={toggleListening}
                                                    className="mic-btn"
                                                >
                                                    <i className={`fa ${listening ? "fa-stop" : "fa-microphone"}`}></i>
                                                </button>
                                            </div>

                                        </div>

                                        {/* Instruction */}
                                        <div className="text-center  mb-4">
                                            <small>
                                                Type or speak Unpaid with 5% GST and no discount
                                            </small>
                                        </div>

                                    </form>
                                    <div
                                        className="d-flex gap-2 justify-content-end"
                                        style={{ marginTop: 20 }}
                                    >
                                        <button
                                            type="reset"
                                            onClick={() => {
                                                prevStep();
                                                SpeechRecognition.stopListening();
                                            }}
                                            className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                        >
                                            Back
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                            onClick={SaveOtherDetails}
                                        >
                                            <Icon icon="simple-line-icons:check" className="text-xl" />
                                           Next
                                        </button>

                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                    {/* Form Wizard End */}
                </div>
            </div>
        </div>
    );
};

export default Aigenerated;
